import { css } from '@emotion/react'
import { Alert, Cell, Grid, Heading, Icon, VFlow } from 'bold-ui'
import { StickyButton } from 'components/sticky-button/StickyButton'
import { useParams } from 'react-router-dom'

import { NewsVersion } from './hooks/useNewsItems'
import { NewsInternalPanel } from './internal-panels/NewsInternalPanel'
import { NewsSideMenu } from './side-menu/NewsSideMenu'

const CURRENT_VERSION: NewsVersion = '5-5-estabilizacao'

export function News() {
  const { version } = useParams<{ version?: NewsVersion }>()
  const selectedVersion = version ?? CURRENT_VERSION

  return (
    <VFlow>
      <Heading level={1}>Novidades</Heading>
      <Grid>
        <Cell size={3} style={styles.cellSideMenuNews}>
          <NewsSideMenu selectedVersion={selectedVersion} />
        </Cell>
        <Cell size={7}>
          <VFlow>
            <Alert type='info' inline>
              <strong>O PEC é frequentemente aprimorado com melhorias e correções!</strong> Para conhecer as próximas
              novidades, o sistema deve ser atualizado com a versão mais recente disponível.
            </Alert>
            <VFlow>
              <NewsInternalPanel version={selectedVersion} />
              <VFlow>
                <StickyButton
                  showsAt={800}
                  size='small'
                  style={{ left: '90%' }}
                  onClick={() => window.scrollTo({ behavior: 'smooth', top: 0 })}
                >
                  <Icon icon='arrowUp' />
                  Voltar ao topo
                </StickyButton>
              </VFlow>
            </VFlow>
          </VFlow>
        </Cell>
      </Grid>
    </VFlow>
  )
}

const styles = {
  cellSideMenuNews: css`
    padding-left: 0 !important;
  `,
}
